import { z } from 'zod'
import { DayTradeSessionState } from '../../enums/day-trade-session-state.enum'

export const dayTradeSessionStateSchema = z.object({
  instrumentUid: z.string(),
  ticker: z.string().nullable(),
  state: z.nativeEnum(DayTradeSessionState),
  errorReason: z.string().nullable(),
  peak: z.number(),
  currentPrice: z.number().nullable(),
  lotsHeld: z.number().int(),
  avgEntry: z.number().nullable(),
  lastBuyPrice: z.number().nullable(),
  lastSellPrice: z.number().nullable(),
  // decision-required signal: when the session is blocked because the account holds lots bought
  // outside the bot, these carry the held quantity (in lots) and the broker average price so the UI
  // can offer to adopt them. both null in every other state.
  heldOutsideLots: z.number().int().nullable(),
  heldOutsideAvgPrice: z.number().nullable(),
})

export type DayTradeSessionStateDto = z.infer<typeof dayTradeSessionStateSchema>
